<template>
  <div class="o-rewards">
    <app-navigation
      :currentSpace="$t('web.rewards_dashboard.nav_space')"
      :hideAuxNavOnDesktop="true"
      :backButton="showBackButton">
    </app-navigation>


    <main class="o-rewards__main">
      <search-bar></search-bar>

      <loading-icon v-if="categoriesLoading"></loading-icon>
      <category-list v-else></category-list>
    </main>


    <app-footer></app-footer>
  </div>
</template>

<script>
import CategoryList from '@/views/components/catalog/CategoryList'
import SearchBar from '@/views/components/catalog/SearchBar'

export default {
  name: 'RewardsDashboard',

  components: {
    CategoryList,
    SearchBar
  },

  data () {
    return { categoriesLoading: true }
  },

  computed: {
    /**
     * Determine whether to show the back button.
     *
     * @return {boolean}
     */
    showBackButton () {
      const isRewardsList = this.$store.getters.rewards.items !== null &&
                            this.$store.getters.rewardDetails === null
      const isReward = this.$store.getters.rewardDetails !== null
      return (window.history.length > 0) && ((isRewardsList) || (isReward))
    }
  },

  created () {
    // Load categories.
    this.$store.dispatch('GET_CATEGORIES', {parent: 0})
      .then(() => {
        this.categoriesLoading = false
      })
      .catch(error => Promise.reject(error))

    this.$store.dispatch('LOAD_PARTICIPANT', this.$router).catch(error => Promise.reject(error))
  }
}
</script>



// WEBPACK FOOTER //
// RewardsDashboard.vue?63dbce50